export default (scroller) => {
  let header = document.getElementById('header');
  let pageAnchors = document.querySelector('.page-anchors');
  let filterList = document.querySelector('.filter-list');

  const HEADER__SCROLL = 'header-scroll';
  const HEADER__HOMESCROLL = 'header-scroll--home';

  let scrollY = 0;

  scroller.on('scroll', (args) => {
    scrollY = args.delta.y;

    if((scrollY > 120) && (document.body.getAttribute('data-page-name') != 'homePage')){
      header.classList.add(HEADER__SCROLL);
    } else {
      header.classList.remove(HEADER__SCROLL);
    }

    if((scrollY > 120) && (document.body.getAttribute('data-page-name') == 'homePage')){
      header.classList.add(HEADER__HOMESCROLL);
    } else {
      header.classList.remove(HEADER__HOMESCROLL);
    }
  });

  let headerAnchorsListContainer = document.querySelector('.header__anchors-list-container');

  if(pageAnchors && headerAnchorsListContainer){

    if(headerAnchorsListContainer){
      headerAnchorsListContainer.innerHTML = '';
    }

    let headerAnchors = document.querySelector('.header__anchors');
    let headerAnchorsText = document.querySelector('.header__anchors-text');

    let pageAnchorsList = document.querySelector('.page-anchors__list');

    let pageAnchorsListClone = pageAnchorsList.cloneNode(true);
    pageAnchorsListClone.classList.add('header__anchors-list');

    headerAnchorsListContainer.appendChild(pageAnchorsListClone);

    headerAnchorsText.innerText = pageAnchorsList.querySelector('.page-anchors__link').innerText;

    scroller.on('scroll', () => {
      let pageAnchorsBound = pageAnchors.getBoundingClientRect();
      let pageAnchorsTop = pageAnchorsBound.top;

      if(scrollY > pageAnchorsTop + pageAnchors.offsetHeight){
        headerAnchors.classList.add('anchors-visible');
        
      } else {
        headerAnchors.classList.remove('anchors-visible');
      }
    });


    let anchorItems = document.querySelectorAll('.page-anchors__link');

    if(anchorItems){
      setAnchors(anchorItems);
    }

    function setAnchors(stickyLinks){
      for(var i = 0; i < stickyLinks.length; i++){
        stickyLinks[i].addEventListener('click', function(e){
          let headerAnchorsText = document.querySelector('.header__anchors-text');

          e.preventDefault();

          for(var j = 0; j < stickyLinks.length; j++){
            stickyLinks[j].classList.remove('current');
          }
          this.classList.add('current');
          var href = this.getAttribute('href');
          var blockEl = document.querySelector(href);

          setTimeout(() => {
            var blockElBound = blockEl.getBoundingClientRect();
            var blockElTop = blockElBound.top;

            scroller.scrollTo(
              blockEl, {
                offset: -130
              }
            );
          }, 100);

          headerAnchorsText.innerText = this.innerText;
        });
      }

      var aArray = [];
      for (var i = 0; i < stickyLinks.length; i++) {    
        var aLink = stickyLinks[i];
        var ahref = aLink.getAttribute('href');
        aArray.push(ahref);
      } 


      scroller.on('scroll', function(){
        let headerAnchorsText = document.querySelector('.header__anchors-text');
        var windowPos = scrollY;

  
        for (var i = 0; i < aArray.length; i++) {
          var theID = aArray[i];
          var theIDBlock = document.querySelector(theID);
          var theIDBlockBound = theIDBlock.getBoundingClientRect();
          var divPos = theIDBlockBound.top + windowPos;
          var divHeight = theIDBlock.clientHeight;
          if (windowPos + 200 >= divPos && windowPos + 200 < (divPos + divHeight)) {
            for(var k = 0; k < stickyLinks.length; k++){
              if(stickyLinks[k].getAttribute('href') == theID){
                stickyLinks[k].classList.add('current');

                headerAnchorsText.innerText = stickyLinks[k].innerText;
              }
            }
          } else {
            for(var k = 0; k < stickyLinks.length; k++){
              if(stickyLinks[k].getAttribute('href') == theID){
                  stickyLinks[k].classList.remove('current');
              }
            }
          }
        }
      });
    }

  }

  if(filterList){
    scroller.on('scroll', () => {
      let headerFilters = document.querySelector('.header__filters');

      let filterListBound = filterList.getBoundingClientRect();
      let filterListTop = filterListBound.top;

      if (headerFilters) {
        if(scrollY > filterListTop + filterList.offsetHeight){
          headerFilters.classList.add('filters-visible');
        } else {
          headerFilters.classList.remove('filters-visible');
        }
      }
    });
  }
  document.addEventListener('readystatechange', function() {
    if (document.readyState === "complete") {
      let links = document.querySelectorAll('a');
      links.forEach(link => {
        link.addEventListener('click', () => {
  
          setTimeout(() => {
            let headerAnchors = document.querySelector('.header__anchors');
            let headerFilters = document.querySelector('.header__filters');
  
            if (headerAnchors) {
              headerAnchors.classList.remove('anchors-visible');
            }
            if (headerFilters) {
              headerFilters.classList.remove('filters-visible');
            }
          }, 400);
        });
      });
    }
  });
  
}